/** Hersteller, deren Farben und Verfügbarkeit über das JAB-Händlerportal abgeglichen werden. */
export const JAB_HERSTELLER_SCHLUESSEL = [
    "jab-josef-anstoetz-kg",
    "jab-gardisette",
    "jab-carlucci",
    "jab-chivasso",
];
export function istJabHersteller(schluessel) {
    return JAB_HERSTELLER_SCHLUESSEL.includes(schluessel);
}
const lfm = (zahl) => `${(Math.round(zahl * 100) / 100).toLocaleString("de-DE")} lfm`;
/** Lieferant, dessen Portal die Verfügbarkeit liefert – so steht er in den Hinweisen. */
export const VERFUEGBARKEITS_LIEFERANTEN = ["JAB", "Sarlas", "ED"];
/**
 * Vergleicht die Menge des Lieferanten mit dem Stoffbedarf der Konfiguration. Reiner Hinweis –
 * auch bei „warnung“ bleibt die Konfiguration gültig. Ohne brauchbare Zahl: „unbekannt“.
 * Ohne Angabe ist der Lieferant JAB.
 */
export function verfuegbarkeitsHinweis(meter, status, bedarfLfm, lieferant = "JAB") {
    if (status === "nicht_verfuegbar") {
        return { stufe: "warnung", text: `Bei ${lieferant} nicht lagernd – Liefertermin erfragen.` };
    }
    if (status === "unbekannt" || meter == null) {
        return { stufe: "unbekannt", text: `Verfügbarkeit nicht eindeutig abrufbar – bitte bei ${lieferant} prüfen.` };
    }
    if (meter >= bedarfLfm) {
        return { stufe: "ok", text: `${lfm(meter)} verfügbar – Bedarf ${lfm(bedarfLfm)} gedeckt.` };
    }
    return {
        stufe: "warnung",
        text: `Nur ${lfm(meter)} verfügbar, Bedarf ${lfm(bedarfLfm)} – Lieferfähigkeit bei ${lieferant} klären.`,
    };
}
//# sourceMappingURL=jab.js.map